import React from "react";

export default function WebFormsEmptyImg(): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="67.239"
      height="136.195"
      viewBox="0 0 67.239 136.195"
    >
      <g id="Shadow" transform="translate(10.427 130.196)">
        <ellipse
          id="Elipse_138"
          data-name="Elipse 138"
          cx="24"
          cy="2.999"
          rx="24"
          ry="2.999"
          fill="#ddd"
          opacity="0.5"
        />
      </g>
      <g id="Bee" transform="translate(1.427)">
        <g id="Line" transform="translate(0 12.715)">
          <path
            id="Line-2"
            data-name="Line"
            d="M31.878,53.082s-21.639,10.643-30.3-9.106,21.088-42.3,23.972-31.548S-4.148,20.852,7.428,0"
            transform="translate(38.155 0) rotate(43)"
            fill="none"
            stroke="#ddd"
            stroke-width="2"
            stroke-dasharray="5 3"
          />
        </g>
        <g id="bee-2" data-name="bee" transform="translate(38.362)">
          <path
            id="Caminho_10042"
            data-name="Caminho 10042"
            d="M5.87,23.906a9.981,9.981,0,0,0,1.935-.2c.326-.065,1.016-.244,1.706-.461,1.33-.419,1.54-.629,1.642-.73a.613.613,0,0,0,.11-.72c-.079-.149-.147-.288-.214-.421a9.83,9.83,0,0,0-.491-.9,7.662,7.662,0,0,0-1.228-1.529,7.752,7.752,0,0,0-2.222-1.625A7.6,7.6,0,0,0,3.924,16.6a3.939,3.939,0,0,0-3.606,1.72c-.595,1.05-.357,2.271.707,3.63a5.969,5.969,0,0,0,2.9,1.717,7.652,7.652,0,0,0,1.94.237Zm0,0"
            transform="translate(0.001 -15.944)"
            fill="#ccc"
            opacity="0.7"
          />
          <path
            id="Caminho_10043"
            data-name="Caminho 10043"
            d="M304.855,6.522a.6.6,0,0,0,.1-.008A5.766,5.766,0,0,0,306.5,5.7a5.08,5.08,0,0,0,1.143-1.15,3.138,3.138,0,0,0,.4-3.122A1.606,1.606,0,0,0,306.586.5a2.456,2.456,0,0,0-1.331.454A3.454,3.454,0,0,0,303.816,3.6a4.3,4.3,0,0,0,.526,2.645A.613.613,0,0,0,304.855,6.522Zm0,0"
            transform="translate(-291.469 -0.5)"
            fill="#bbb"
          />
          <path
            id="Caminho_10044"
            data-name="Caminho 10044"
            d="M359.254,188.241a6.268,6.268,0,0,0-5.6-3.877,8.438,8.438,0,0,0,.263,5.86,8.141,8.141,0,0,0,4.124,4.707A6.293,6.293,0,0,0,359.254,188.241Zm0,0"
            transform="translate(-338.933 -176.962)"
            fill="#fb972e"
          />
          <path
            id="Caminho_10045"
            data-name="Caminho 10045"
            d="M225.942,192.933a9.886,9.886,0,0,1-.446-6.2,6.3,6.3,0,0,0-1.287.379,9.942,9.942,0,0,0-3.194,2.453,12.911,12.911,0,0,0,.9,4.85,12.658,12.658,0,0,0,3.139,4.761c.271.011.536.018.791.018a8.6,8.6,0,0,0,3.175-.469,6.274,6.274,0,0,0,1.173-.639A9.666,9.666,0,0,1,225.942,192.933Zm0,0"
            transform="translate(-212.099 -179.233)"
            fill="#333"
          />
          <path
            id="Caminho_10046"
            data-name="Caminho 10046"
            d="M130.293,290.383q-.151.2-.3.407c-1.468,2.051-2.345,4.074-2.345,5.412,0,.588.609.919,1.14,1.141a13.215,13.215,0,0,0,2.042.616,26.639,26.639,0,0,0,2.837.485,14.487,14.487,0,0,1-2.448-4.174A14.7,14.7,0,0,1,130.293,290.383Zm0,0"
            transform="translate(-122.474 -278.651)"
            fill="#fb972e"
          />
        </g>
        <g id="Plus" transform="translate(60.812 30.177)">
          <line
            id="Linha_225"
            data-name="Linha 225"
            y2="4"
            transform="translate(2)"
            fill="none"
            stroke="#707070"
            stroke-linecap="round"
            stroke-width="2"
          />
          <line
            id="Linha_226"
            data-name="Linha 226"
            y2="4"
            transform="translate(4 2) rotate(90)"
            fill="none"
            stroke="#707070"
            stroke-linecap="round"
            stroke-width="2"
          />
        </g>
        <g
          id="Elipse_136"
          data-name="Elipse 136"
          transform="translate(54.412 42.577)"
          fill="#fff"
          stroke="#707070"
          stroke-width="1"
        >
          <circle cx="0.8" cy="0.8" r="0.8" stroke="none" />
          <circle cx="0.8" cy="0.8" r="0.3" fill="none" />
        </g>
        <g
          id="Elipse_137"
          data-name="Elipse 137"
          transform="translate(23.212 16.977)"
          fill="none"
          stroke="#707070"
          stroke-width="1"
        >
          <circle cx="1.6" cy="1.6" r="1.6" stroke="none" />
          <circle cx="1.6" cy="1.6" r="1.1" fill="none" />
        </g>
      </g>
      <g clip-path="url(#clip0)">
        <path
          d="M55.4245 94.2C54.5981 94.1535 53.8247 93.8131 53.2708 93.2521C52.717 92.691 52.4268 91.9541 52.4629 91.2V80.34C52.499 79.5859 52.2089 78.849 51.655 78.2879C51.1011 77.7269 50.3277 77.3865 49.5014 77.34H19.6594C18.833 77.3865 18.0597 77.7269 17.5058 78.2879C16.9519 78.849 16.6618 79.5859 16.6978 80.34V111C16.6618 111.754 16.9519 112.491 17.5058 113.052C18.0597 113.613 18.833 113.954 19.6594 114H32.0611C32.8738 114.079 33.6258 114.428 34.1724 114.982C34.719 115.536 35.0214 116.255 35.0214 117C35.0214 117.745 34.719 118.464 34.1724 119.018C33.6258 119.572 32.8738 119.921 32.0611 120H16.9242C15.2695 119.912 13.7195 119.233 12.6107 118.109C11.5018 116.986 10.9235 115.51 11.0011 114V78C10.9235 76.4905 11.5018 75.0139 12.6107 73.8907C13.7195 72.7674 15.2695 72.0881 16.9242 72H52.4629C54.1177 72.0881 55.6676 72.7674 56.7765 73.8907C57.8853 75.0139 58.4637 76.4905 58.386 78V91.2C58.4221 91.9541 58.132 92.691 57.5781 93.2521C57.0242 93.8131 56.2509 94.1535 55.4245 94.2V94.2Z"
          fill="#DDDDDD"
        />
        <path
          d="M42.5899 105.6H26.795C26.0968 105.6 25.4272 105.347 24.9335 104.897C24.4398 104.447 24.1625 103.837 24.1625 103.2C24.1625 102.563 24.4398 101.953 24.9335 101.503C25.4272 101.053 26.0968 100.8 26.795 100.8H42.5899C43.2881 100.8 43.9577 101.053 44.4514 101.503C44.9451 101.953 45.2224 102.563 45.2224 103.2C45.2224 103.837 44.9451 104.447 44.4514 104.897C43.9577 105.347 43.2881 105.6 42.5899 105.6Z"
          fill="#DDDDDD"
        />
        <path
          d="M42.5899 96.96H26.795C26.0968 96.96 25.4272 96.7071 24.9335 96.257C24.4398 95.807 24.1625 95.1965 24.1625 94.56C24.1625 93.9235 24.4398 93.313 24.9335 92.8629C25.4272 92.4128 26.0968 92.16 26.795 92.16H42.5899C43.2881 92.16 43.9577 92.4128 44.4514 92.8629C44.9451 93.313 45.2224 93.9235 45.2224 94.56C45.2224 95.1965 44.9451 95.807 44.4514 96.257C43.9577 96.7071 43.2881 96.96 42.5899 96.96Z"
          fill="#DDDDDD"
        />
        <path
          d="M42.5899 88.32H26.795C26.0968 88.32 25.4272 88.0672 24.9335 87.6171C24.4398 87.167 24.1625 86.5565 24.1625 85.92C24.1625 85.2835 24.4398 84.673 24.9335 84.2229C25.4272 83.7729 26.0968 83.52 26.795 83.52H42.5899C43.2881 83.52 43.9577 83.7729 44.4514 84.2229C44.9451 84.673 45.2224 85.2835 45.2224 85.92C45.2224 86.5565 44.9451 87.167 44.4514 87.6171C43.9577 88.0672 43.2881 88.32 42.5899 88.32Z"
          fill="#DDDDDD"
        />
        <path
          d="M55.7787 100.488L57.6478 98.784C58.141 98.337 58.8082 98.0861 59.5037 98.0861C60.1992 98.0861 60.8664 98.337 61.3596 98.784L63.2287 100.488C63.719 100.938 63.9942 101.546 63.9942 102.18C63.9942 102.814 63.719 103.422 63.2287 103.872L61.3596 105.576L55.7787 100.488ZM53.9097 102.192L40.326 114.576C40.2059 114.686 40.1114 114.818 40.0481 114.962C39.9848 115.106 39.954 115.261 39.9574 115.416V118.8C39.9574 119.118 40.0961 119.423 40.343 119.649C40.5898 119.874 40.9246 120 41.2737 120H44.9855C45.1582 120.002 45.3294 119.971 45.4881 119.909C45.6468 119.847 45.7895 119.755 45.9069 119.64L59.4906 107.256L53.9097 102.192Z"
          fill="#DDDDDD"
        />
      </g>
    </svg>
  );
}
